define(function (require) {
    "use strict";

	var LE = require("app");
    var Page = require("ui.components/page/Page");

    var ContentCannedEditLayout = require("content-views/content-edit/canned/ContentCannedEditLayout");
    var EditCannedTextView = require("content-views/content-edit/canned/EditCannedTextView");
    var ContentCannedEditPageModel = require("content-models/canned/ContentCannedEditPageModel");
    var ContentCannedModel = require("content-models/canned/ContentCannedModel");
    var ContentCannedDefaultsModel = require("content-models/canned/ContentCannedDefaultsModel");
    var cannedMessageConfig = require("content-config/cannedMessageConfig.json");

    var StringFormats = require("utils/StringFormats");
    var ErrorCodes = require("codeTables/errorCodes.json");

    var ContentCannedEditController = {};

    var ADDITIONAL_PAGE_CLASS_NAME = "predefined-messages-edit-page";

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedEditController = Marionette.Controller.extend({
            initialize: function (options) {
                LEContent.logger.info("initializing", "ContentCannedEditController:initialize");

                this.channel = LEContent.media.channel("ContentCannedEditController");
                this.reqres = this.channel.reqres;

                this.channel.reset();

                this.model = new ContentCannedEditPageModel();

                this.createViews();
                this.bindEvents();
                this.bindRequests();
            },
            createViews: function(){
                this.contentCannedEditLayout = new ContentCannedEditLayout({
                    model: this.model,
                    reqres: this.reqres,
                    channel: this.channel
                });

                this.mainView = new Page({
                    moduleName:LEContent.moduleName,
                    context:LE.context,
                    isPermanent: true,
                    view:        this.contentCannedEditLayout,
                    additionalClassName:  ADDITIONAL_PAGE_CLASS_NAME,
                    header: {
                        title:       "",
                        description: ""
                    }
                });
            },
            bindEvents: function () {
                var that = this;
                //layout view
                this.listenTo(this.channel, "contentCannedEditLayout:actions:restoreToDefaults", this._restoreToDefaults);
                this.listenTo(this.channel, "contentCannedEditLayout:cancel", this._cancelEdit);
                this.listenTo(this.channel, "contentCannedEditLayout:closeWindow", this._cancelEdit);
                this.listenTo(this.channel, "contentCannedEditLayout:changePage", this._changePage);
                this.listenTo(this.channel, "contentCannedEditLayout:saveAndAddAnother", this._saveAndNew);
                this.listenTo(this.channel, "contentCannedEditLayout:save", this._save);

                //editor view events
                this.listenTo(this.channel, "editorCannedWrapperView:title:change", this._contentTitleChanged);
                this.listenTo(this.channel, "editorCannedWrapperView:editor:text:change", this._contentMessageChanged);

                //canned text edit events
                this.listenTo(this.channel, "editCannedTextView:toggle:activate:change", this._enabledStateChanged);
                this.listenTo(this.channel, "editCannedTextView:categories:change", this._categoriesChanged);
                this.listenTo(this.channel, "editCannedTextView:skills:change", this._skillsChanged);
                this.listenTo(this.channel, "editCannedTextView:lobs:change", this._lobsChanged);

                this.listenTo(this.model,"change:header.*",this._showHeaderAccordingToModel);

                //canned hotkeys change event
                this.listenTo(this.channel, "hotKeysCannedView:hotkeys:change", this._hotKeysChanged);

                //Selected/Default site languages Changed
                this.listenTo(LE.vent, "siteSettings:supportedDefaultLanguageCodesChanged", this._siteLanguagesChange, this);

            },
            bindRequests: function(){
                this.reqres.setHandler("tabsbar:language:validateContentPreLanguageChange", this._validateContentPreLanguageChange, this);
            },
            _siteLanguagesChange: function(languagesChanges){
                //before updating the tabs find out what was added, what was removed
                var removedLanguages = this.model.getRemovedLanguageCodes();
                var addedLanguageCodes = this.model.getAddedLanguageCodes();

                this.model.initLanguageTabs(); //Update the tabs - for the view

                //Then update the data:
                if (this.model.isContentEmpty() || this.model.getIsContentNew() ){
                    //do not update model languages data if its a new model or the empty model
                } else {
                    this.model.deleteRemovedLanguagesData(removedLanguages);
                    this._fetchMissingLanguages(addedLanguageCodes);
                }
            },
            /**
             * add data of added languages if exists in the server DB
             * @param missingLanguageCodes
             * @private
             */
            _fetchMissingLanguages: function(missingLanguageCodes){
                if (missingLanguageCodes.length !== 0) {
                    this._showLoader();
                    var tempModel = null;
                    tempModel = new ContentCannedModel({ "id": this.model.getModelID()});

                    var that = this;
                    tempModel.fetch({
                        success: function (model, response, options) {
                            that.model.appendAddedLanguagesData(model, missingLanguageCodes);
                            that._closeLoader();
                        },
                        error: function (model, response, options) {
                            LEContent.logger.debug("fetch content error", "ContentCannedEditController:_fetchMissingLanguages");
                            that._closeLoader();
                        }
                    });
                }
            },
            //functions called from router:
            editCannedMessage: function (options) {
                LEContent.logger.debug("edit text content", "ContentCannedEditController:editCannedMessageText");
                if (options.contentId == this.model.getContentModel().id ) {    //doing == to use "12123" == 12123 = true
                    //show already loaded or in edit content
                } else {
                    this._editCannedMessage(options);
                }
            },
            _fetchInUseHotKeysCollection: function(success, error){
                this.model.fetchInUseHotKeysCollection(success, error);
            },
            _editCannedMessage: function (options) {
                LEContent.logger.debug("fetching text content for edit", "ContentCannedEditController:_editCannedMessageText");
                this._showLoader();
                var contentModel = new ContentCannedModel({ "id": options.contentId});
                //lets use after to show the page only after model, in use hotkeys collection and categories and skills and if lob is enabled so lob and logged in user are available
                var numOfFetches = this._isTaggingByLobFeatureEnabled() ? 6 : 4;

                var renderEditPage = _.after(numOfFetches, _.bind(function(){
                    this._prepareModel(contentModel);
                    this._showCannedTextEdit();
                    this._closeLoader();
                }, this));

                var errorMessage = LE.translator.translate("LEContent.content.edit.get.data.error");
                this._fetchCategoriesCollection(renderEditPage, errorMessage);
                this._fetchSkillsCollection(renderEditPage, errorMessage);
                if (this._isTaggingByLobFeatureEnabled()) {
                    this._fetchLobsCollection(renderEditPage, errorMessage);
                    this._fetchLoggedInUserModel(renderEditPage, errorMessage);
                }

                contentModel.fetch({
                    success: _.bind(function (model, response, options) {
                        LEContent.logger.debug("fetch content canned success ", "ContentCannedEditController:editCannedMessage");
                        renderEditPage();
                    }, this),
                    error: _.bind(function (model, response, options) {
                        LEContent.logger.debug("fetch content canned error closing loader returning to list", "ContentCannedEditController:editCannedMessage");
                        if (response && response.responseError) {
                            if (response.responseError.internalCode == ErrorCodes.noDataFound) {
                                LEContent.notifier.showError({
                                    content: LE.translator.translate("LEContent.content.edit.errors.missing.deleted.msg"), timeToShow: 6000});
                            } else if (!_.isEmpty(response.responseError.message)) {
                                LEContent.notifier.showError({content: response.responseError.message, timeToShow: 6000});
                            }
                        } else {
                            LEContent.notifier.showError(LE.translator.translate("LEContent.content.edit.get.data.error"));
                        }
                        this._closeLoader();
                        this._routeToTable();
                    }, this)
                });

                this._fetchInUseHotKeysCollection(renderEditPage, this._closeLoader);
            },

            newCannedMessageText: function () {
                if(this.model.isContentEmpty() || !this.model.getIsContentNew()){
                    LEContent.logger.debug("Creating new text content", "ContentCannedEditController:newCannedMessageText");
                    this._showLoader();
                    //lets use after to show the page only after the in use hotkeys collection, skills and categories are available and if lob feature is enabled also lobs and logged in user
                    var numOfFetches = this._isTaggingByLobFeatureEnabled() ? 5 : 3;
                    var renderNewPage = _.after(numOfFetches, _.bind(function(){
                        this._prepareModel(new ContentCannedModel());
                        this._showCannedTextEdit();
                        this._closeLoader();
                    }, this));

                    var errorMessage = LE.translator.translate("LEContent.content.edit.create.data.error");
                    this._fetchCategoriesCollection(renderNewPage, errorMessage);
                    this._fetchSkillsCollection(renderNewPage, errorMessage);
                    if (this._isTaggingByLobFeatureEnabled()) {
                        this._fetchLobsCollection(renderNewPage, errorMessage);
                        this._fetchLoggedInUserModel(renderNewPage, errorMessage);
                    }

                    this._fetchInUseHotKeysCollection(renderNewPage, this._closeLoader);

                } else { //returning to new content in the middle of edit
                    this._showCannedTextEdit();
                }

            },
            newCannedMessageVideo: function () {
                LEContent.logger.debug("Creating new text content", "ContentCannedEditController:newCannedMessageText");
                this._prepareModel(new ContentCannedModel());//todo something with video type/ or different model
                this._showCannedVideoEdit();
            },
            _prepareModel: function(model){
                this.model.setContentModel(model);
                this.listenTo(model,"invalid",this._onInvalidModel);
            },
            _showHeaderAccordingToModel: function () {
                var header = this.model.getHeader();
                var title =        _.isString(header.title) && header.title.length > 0? LE.translator.translate(header.title): "";
                var description =  _.isString(header.description) && header.description.length > 0? LE.translator.translate(header.description): "";

                this.mainView.setTitle(title);
                this.mainView.setDescription(description);
            },

            _fetchCategoriesCollection: function(callback, errorMessage) {
                var categoriesCollection = LE.crossModule("manager", LE.media.actions.request, LE.mediaCodes.manager.reqres.getCategories);
                if (categoriesCollection.fetchState !== categoriesCollection.FetchStateEnum.SUCCESS) {
                    categoriesCollection.fetch({
                        success: _.bind(function (collection, response, options) {
                            LEContent.logger.debug("fetch categories success ", "ContentCannedEditController:editCannedMessage");
                            callback();
                        }, this),
                        error: _.bind(function (collection, response, options) {
                            LEContent.logger.debug("fetch categories error closing loader returning to list", "ContentCannedEditController:editCannedMessage");
                            if (response && response.responseError && !_.isEmpty(response.responseError.message)) {
                                LEContent.notifier.showError({content: response.responseError.message, timeToShow: 6000});
                            } else {
                                LEContent.notifier.showError(errorMessage);
                            }
                            this._closeLoader();
                            this._routeToTable();
                        }, this)
                    });
                } else {
                    callback();
                }
            },

            _fetchSkillsCollection: function(callback, errorMessage) {
                var skillsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getSkillsCollection);
                if (skillsCollection.fetchState !== skillsCollection.FetchStateEnum.SUCCESS) {
                    skillsCollection.fetch({
                        success: _.bind(function (collection, response, options) {
                            LEContent.logger.debug("fetch skills success ", "ContentCannedEditController:editCannedMessage");
                            callback();
                        }, this),
                        error: _.bind(function (collection, response, options) {
                            LEContent.logger.debug("fetch skills error closing loader returning to list", "ContentCannedEditController:editCannedMessage");
                            if (response && response.responseError && !_.isEmpty(response.responseError.message)) {
                                LEContent.notifier.showError({content: response.responseError.message, timeToShow: 6000});
                            } else {
                                LEContent.notifier.showError(errorMessage);
                            }
                            this._closeLoader();
                            this._routeToTable();
                        }, this)
                    });
                } else {
                    callback();
                }
            },

            _fetchLobsCollection: function(callback, errorMessage) {
                var lobsCollection = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLobsCollection);
                if (lobsCollection.fetchState !== lobsCollection.FetchStateEnum.SUCCESS) {
                    lobsCollection.fetch({
                        success: _.bind(function (collection, response, options) {
                            LEContent.logger.debug("fetch lobs success ", "ContentCannedEditController:editCannedMessage");
                            callback();
                        }, this),
                        error: _.bind(function (collection, response, options) {
                            LEContent.logger.debug("fetch lobs error closing loader returning to list", "ContentCannedEditController:editCannedMessage");
                            if (response && response.responseError && !_.isEmpty(response.responseError.message)) {
                                LEContent.notifier.showError({content: response.responseError.message, timeToShow: 6000});
                            } else {
                                LEContent.notifier.showError(errorMessage);
                            }
                            this._closeLoader();
                            this._routeToTable();
                        }, this)
                    });
                } else {
                    callback();
                }
            },

            _fetchLoggedInUserModel: function(callback, errorMessage) {
                var loggedInUserModel = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getLoggedInUserModel);
                if (loggedInUserModel.fetchState !== loggedInUserModel.FetchState.SUCCESS && !LE.sessionManager.getConfig().isLPA) {
                    loggedInUserModel.fetch({
                        success: _.bind(function (model, response, options) {
                            LEContent.logger.debug("fetch logged in user success ", "ContentCannedEditController:editCannedMessage");
                            callback();
                        }, this),
                        error: _.bind(function (model, response, options) {
                            LEContent.logger.debug("fetch logged in user error closing loader returning to list", "ContentCannedEditController:editCannedMessage");
                            if (response && response.responseError && !_.isEmpty(response.responseError.message)) {
                                LEContent.notifier.showError({content: response.responseError.message, timeToShow: 6000});
                            } else {
                                LEContent.notifier.showError(errorMessage);
                            }
                            this._closeLoader();
                            this._routeToTable();
                        }, this)
                    });
                } else {
                    callback();
                }
            },

            _showLoader: function(){
                this.mainView.showLoader();
            },
            _closeLoader: function(){
                this.mainView.closeLoader();
            },

            _showCannedTextEdit: function () {
                LEContent.logger.debug("show cannedHtml", "ContentCannedEditController:showContent");

                if (!this.contentCannedEditLayout.leftPane.currentView) {
                    var editCannedTextView = new EditCannedTextView({channel: this.channel,reqres: this.reqres, model: this.model, isTaggingByLobFeatureEnabled:this._isTaggingByLobFeatureEnabled()});
                    this.contentCannedEditLayout.leftPane.show(editCannedTextView);
                }
            },

            _showCannedVideoEdit: function () {
                LEContent.logger.debug("show _showCannedVideoEdit", "ContentCannedEditController:_showCannedVideoEdit");
                //todo
            },
            _validateContentPreLanguageChange: function() {
                 return this.model.validateContent();
            },

            _contentTitleChanged: function (title) {
                this.model.setContentTitle(title);
            },
            _contentMessageChanged: function (message) {
                this.model.setContentMessage(message);
            },

            _restoreToDefaults: function(){
                var that = this;
                var tempModel = null;
                this._showLoader();

                tempModel = new ContentCannedDefaultsModel({ "id": this.model.getTemplateId()});

                tempModel.fetch({
                    success: function (model, response, options) {
                        that.model.setDefaultLanguageData(model.get("data"));
                        that._contentMessageChanged(that.model.getContentMessage());
                        that._closeLoader();
                    },
                    error: function (model, response, options) {
                        LEContent.logger.debug("fetch content error", "ContentCannedEditController:_restoreToDefaults");
                        that._closeLoader();
                    }
                });
            },
            _enabledStateChanged: function (state) {
                this.model.setEnabledState(state);
            },
            _categoriesChanged: function (catArray) {
                this.model.setCategories(catArray);
            },
            _skillsChanged: function (skillsArray) {
                this.model.setSkills(skillsArray);
            },
            _lobsChanged: function (lobsArray) {
                this.model.setLobs(lobsArray);
            },
            _hotKeysChanged : function(hotkeys){
                this.model.setCannedContentHotKeys(hotkeys);
            },

            //Navigation functions
            _cancelEdit: function () {
                this._clear();
                this._routeToTable();
            },

            _changePage: function(idx){
                this.model.setContentPageInfoCurrentPage(idx);
                var that = this;
                var viewInvalid = this._validateView() > 0;
                if (this.model.hasChanges() || viewInvalid){
                    //prompt user if to continue and lose changes or cancel and stay on the page?
                    this.model.setAllowMiniErrors(false); // hide mini errors when prompt is on, and page is about to be changed
                    this.confirmNotifier = LEContent.notifier.showConfirm({
                        title: LE.translator.translate("LEFramework.global.captions.are.you.sure"),
                        content: LE.translator.translate("LEContent.content.edit.route.confirmation.msg"),
                        removeMiddleButton: false,
                        objectAction: {
                            text: LE.translator.translate("LEContent.content.edit.route.confirmation.save"),
                            callback: function() {
                                that.confirmNotifier.close();
                                delete that.confirmNotifier;
                                that.model.setAllowMiniErrors(true);
                                that._save(that._routeToItem, [idx]);
                            },
                            textMiddleButton: LE.translator.translate("LEContent.content.edit.route.confirmation.dont.save"),
                            middleCallback:function() {
                                that.confirmNotifier.close();
                                delete that.confirmNotifier;
                                that.model.setAllowMiniErrors(true);
                                that._routeToItem(idx);
                            },
                            cancelCallback:function() {
                                that.confirmNotifier.close();
                                delete that.confirmNotifier;
                                that.model.setAllowMiniErrors(true);
                                that.model.revertContentPageNumberChange();   //revert the page number change
                            }
                        }
                    });
                } else {
                    this._routeToItem(idx);
                }
            },

            _routeToItem: function (idx){
                this._clear();
                var itemId = LEContent.reqres.request("canned:content-edit:itemIdByIndex",this.model.getContentModel(),idx);
                var route = this._getBaseRoute();
                if (itemId > -1) {
                    route = route + itemId;
                }
                LEContent.logger.debug("Routing to: " + route, "ContentCannedEditController:_previousItem");
                LEContent.router.navigateNonBackable(route);
            },

            _getBaseRoute: function() {
                return "content/canned/";
            },
            _save: function (successCallbackFunction,args) {
                successCallbackFunction = successCallbackFunction || this._routeToTable;
                var callBackParam = args? args[0]: null;

                var modelToSave = this.model.getContentModel();

                var that = this;
                if (this._validateView(modelToSave) === 0) {
                    this._showLoader();
                    modelToSave.save(null, {
                        success: function (model, resp, options) {
                            that._closeLoader();
                            that._clear();
                            successCallbackFunction.call(that, callBackParam);
                        },
                        error: function (model, response, options) {
                            that._closeLoader();
                            LEContent.logger.error("Failed to save content", "ContentCannedEditController:_save", response);
                            if (response && response.responseError) {
                                if (response.responseError.internalCode == ErrorCodes.uniquenessViolation) {
                                    LEContent.notifier.showError({
                                        content: LE.translator.translate("LEContent.content.edit.errors.hotkeys.taken.msg"), timeToShow: 6000});
                                } else if (response.responseError.internalCode == ErrorCodes.noDataFound) {
                                    LEContent.notifier.showError({
                                        content: LE.translator.translate("LEContent.content.edit.errors.missing.deleted.msg"), timeToShow: 6000});
                                } else if (response.responseError.internalCode == ErrorCodes.maxEntityLimitViolation) {
                                    LEContent.notifier.showError({
                                        content: LE.translator.translate("LEContent.content.errors.max.entity.count"), timeToShow: 6000});
                                } else if (response.responseError.internalCode == ErrorCodes.maxActionsLimitViolation) {
                                    LEContent.notifier.showError({
                                        content: LE.translator.translate("LEContent.content.errors.max.number.of.actions"), timeToShow: 6000});
                                } else if (response.responseError.internalCode == ErrorCodes.deleteLastEntityInPredefinedContent) {
                                    LEContent.notifier.showError({
                                        content: LE.translator.translate("LEContent.content.edit.errors.remove.last.content.msg"), timeToShow: 6000});
                                } else if (response.responseError.internalCode == ErrorCodes.maxExportRecords) {
                                    LEContent.notifier.showError({
                                        content: LE.translator.translate({key: "LEContent.content.edit.errors.contentMaxCharacters",  args: [cannedMessageConfig.maxMessageSize]}), timeToShow: 6000});
                                }else if (!_.isEmpty(response.responseError.message)) {
                                    LEContent.notifier.showError({content: response.responseError.message, timeToShow: 6000});
                                }
                            }
                            that.model.revertContentPageNumberChange();
                        }
                    });
                }
                else {   //we have view validation errors lets activate model validation to show all together now
                    LEContent.logger.debug("validateView Failed", "ContentCannedEditController:onSave");
                    modelToSave.isValidAttr();
                }
            },
            _saveAndNew: function () {
                //after save navigate to new content url
                this._save(function (){
                    this._clear();
                    //after a successful save call controller new function - we do not use route as the route stays the same: canned/new/text
                    this.newCannedMessageText();
                });

            },

            //check for view errors in the inner components
            _validateView : function(model) {
                var errCount = this.contentCannedEditLayout.validateView();
                if (model) {
                    model.attributes.viewErrors = errCount;
                }
                return errCount;
            },

            _routeToTable: function () {
                LEContent.router.navigateBack();
            },
            _clear: function () {
                this.stopListening(this.model.getContentModel());
                this.model.clear();
            },

            //error handling
            _onInvalidModel:function (model, errors) {
                this._closeLoader();
                this.model.revertContentPageNumberChange();

                LEContent.logger.debug("Content message is invalid.", "ContentCannedEditController:_invalidModel");
                var numOfErrors = _.keys(errors).length;
                if (model.attributes.viewErrors > 0){
                    numOfErrors+=model.attributes.viewErrors-1;
                }
                LEContent.notifier.showError(StringFormats.getGeneralErrorMsgByNumOfErrors(numOfErrors));

                var i = 0;
                _.each(errors,function(val,key){
                    i++;
                    LEContent.logger.debug("validation error msg "+i+": "+key+" - "+val,"ContentCannedEditController:_invalidModel");
                });
            },

            _isTaggingByLobFeatureEnabled: function() {
                return LE.sessionManager.hasEntitiesTaggingByLobFeature();
            },

            onClose: function () {
                LEContent.logger.info("closing", "ContentCannedEditController:close");
                this.contentCannedEditLayout.close();
                this.mainView.close();
                this.channel.reset();
            },

            getMainView: function () {
                return this.mainView;
            }
        });
    });
    return  ContentCannedEditController;
});
